import { FileService } from "@/core/services";

/**
 * Get folder path based on destination type
 * @param {string} destinationType - Type of the destination (CITY or COUNTRY)
 * @returns {string} - Folder path
 */
export function getFolderPathByDestinationType(destinationType) {
    return destinationType === "CITY"
        ? "/destinations/cities"
        : "/destinations/countries";
}

/**
 * Get file extension from file name
 * @param {string} fileName - Name of the file
 * @returns {string} - File extension
 */
export function getFileExtension(fileName) {
    const lastDot = fileName.lastIndexOf(".");
    if (lastDot === -1 || lastDot === 0) {
        return "";
    }
    return fileName.substring(lastDot + 1);
}

/**
 * Get file name based on image type and destination slug
 * @param {string} imageType - Type of the image (COVER or THUMBNAIL)
 * @param {string} destinationSlug - Slug of the destination
 * @param {string} extension - File extension
 * @returns {string} - Generated file name
 */
export function getFileName(imageType, destinationSlug, extension) {
    if (imageType === "COVER") {
        return `${destinationSlug}.${extension}`;
    } else if (imageType === "THUMBNAIL") {
        return `${destinationSlug}-min.${extension}`;
    }
}

/** Upload image to the server
 * @param {string} folderPath - Path to the folder
 * @param {string} fileName - Name of the file
 * @param {File} file - File object to be uploaded
 * @returns {Promise<string|null>} - URL of the uploaded file or null if upload fails
 */
export async function uploadDestinationImage(folderPath, fileName, file) {
    let fileData = FileService.generateStaticResourceData(
        folderPath,
        fileName
    );
    let queryString = FileService.buildQueryString(fileData);
    let urlFile = await FileService.uploadDestinationImage(file, queryString);
    if (urlFile) {
        return urlFile;
    }
    return null;
}